import React, {Fragment, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import {mostrarAppUserById} from '../../redux/reducers/appUsersReducers';
import EnviarNotificacion from "./EnviarNotificacion";

import {formatDate, formatPeso,} from '../../helpers';
import {
  Button,
  ButtonGroup,
  Drawer,
  Grid,
  Hidden,
  Menu,
  MenuItem,
  Paper,
  Theme,
  Typography,
  useMediaQuery
} from '@mui/material';
import {ArrowDropDown, KeyboardArrowDown, MoreHoriz} from '@mui/icons-material';

// import HacerPago from './addPago'
import Strings from "../../assets/strings";
import NoImg from '../../assets/img/defaultAvatar.jpg';
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import ListNotasUser from "./ListNotasUser";
import {AppBar, LoadingProgress} from "../../components";
import {IAppUser} from "../../redux/types/IAppUser";
import ListPagosUser from "./ListPagosUser";
import ListModulosUser from "./ListModulosUser";
import AgregarPagoUser from "./AgregarPagoUser";
import EditarDrawer from "./EditarDrawer";

const useStyles = makeStyles((theme:Theme) => ({
  clientAvatar: {
    textAlign: "center",
    padding: 20,
    border: "1px solid #ddd",
    height: 138,
    [theme.breakpoints.down('md')]: {
      textAlign: "left",
      padding: "9px 16px 8px",
      border: "none",
      background: theme.palette.primary.main,
      color:"white",
      display: "flex",
      justifyContent: "start",
      top: 50,
      alignItems: "center",
      height: "auto",
      position: "fixed",
      width: "100%",
      zIndex: 1,


      borderBottom:"2px solid transparent",

      "&.estado3, &.estado4":{//ANULADO
        borderBottom: "2px solid #d84315",
      },
      "&.estado5":{//REENGANCHADO
        borderBottom: "2px solid #15d2d8",
      },
      "&.situacion4":{//CUOTASVENCIDA
        borderBottom: "2px solid #d84315",
      },
      "&.situacion3":{//mora
        borderBottom: "2px solid #ff6f00",
      },
      "&.situacion2":{ //pendiente
        borderBottom: "2px solid #1976d2",
      },
    },



  },
  imgCont:{
    width: 100,
    height: 100,
    marginBottom:8,
    margin: "0 auto",
    position: "relative",
    [theme.breakpoints.down('md')]: {
      margin: "0",
      marginRight: theme.spacing(2),
      height: 45,
      width: 45,
      "& img":{
        width: 45,
        height: 45,
      }
    },

  },
  contentInner:{
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  estadoRating:{
    [theme.breakpoints.down('md')]: {
      display:"flex",
    },

  },
  estado:{
    marginTop: 10,
    textAlign: "center",
    height: 16,
    padding: "7px 14px",
    background: "#eceeef",
    [theme.breakpoints.down('md')]: {
      // marginTop: 0,
      // marginBottom:theme.spacing(1),
      display:"none",
    },
    "&.cancelado":{
      background:"#ff3c3c",
    },
    "&.aviso":{
      background:"#fdc661",
    },
    "&.cuotasAtrasadas":{
      background: "#fd6f61",
    },
  },
  imgCircle: {
    borderRadius: "50%",
    [theme.breakpoints.down('md')]: {
      borderRadius: theme.shape.borderRadius,
    },
  },
  controls:{
    paddingTop: 10,
    overflowX: 'auto',
    boxShadow: "none",
    borderRadius: 0,
    "& > div":{
      // minWidth: 479,
    },
    "& a , button:not(:first-child)":{
      // textTransform: "capitalize",
      fontWeight: "normal",
      fontSize: ".9rem",
    },
    [theme.breakpoints.down('xl')]: {
      textAlign: "center",
    }
  },
  table: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(3),
    },
    marginBottom: 35,
  },
  button: {
    // marginLeft: theme.spacing(1),
    color:"inherit",
    background: "#f5f5f5",
    padding: "3px 9px",
    marginLeft: 3,

  },
  info:{
    overflowX: "auto",
    overflowY: "hidden",

    padding: 10,
    [theme.breakpoints.up('md')]: {
      background:"#eceeef",
      padding: 6,
      boxShadow: "none",
      borderRadius: 0,
      "&:not(.all)":{
        height: 167,
      },
      "&>div":{
        minWidth: 785,
      }
    },
    position: "relative",
    [theme.breakpoints.down('md')]: {
      padding: 0,
      margin: "66px 0 0 0px",
      borderRadius: "0",
      boxShadow: "none"
    },
  },
  itemInfo:{
    //...theme.typography.subheading,
    padding: "10px !important",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    [theme.breakpoints.down('md')]: {
      display: "flex",
      flexDirection: "column-reverse",
      padding: "5px 16px !important",
    },
    "& span:last-child":{
      background: "#f6f6f6",
      padding: "5px 13px",
      marginLeft: 10,
      [theme.breakpoints.down('md')]: {
        background: "none",
        marginLeft: 0,
        padding: 0,
        fontSize: "0.9rem",
      },
    },
    "& span:first-child":{
      [theme.breakpoints.down('md')]: {
        display: "block",
        fontSize: ".7rem",
      },
    }
  },
  topBar:{
    display: "flex",
    justifyContent: "end",
    background: "#edeeef",
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      background: theme.palette.primary.main+" !important",
      marginBottom: "0px !important",
      position: "fixed",
      width: "100%",
      zIndex: 1,
      "& *":{
        color:theme.palette.common.white,
      },
    },
  },
  btnMoreInfo:{
    position:"absolute",
    right:theme.spacing(2),
    cursor:"pointer",
  },
  moreInfo:{
    background:theme.palette.grey[100],
    "& span":{
      fontSize: 15,
    }
  },
  cancelBox:{
    "& .title":{
      background: "#ffdede",
    },
    "& textarea":{
      width: "calc(100% - 7px)",
      border: "1px solid #e6e6e6",
      resize: "none",
    },
    "& .content":{
      padding: "10px 10px 0 10px",
    }
  },
  contGrid:{
    [theme.breakpoints.down('md')]: {
      padding: "0px !important",
      margin: "0px !important",
    },
  },
  btnPagoRapido:{
    position: "absolute",
    width: 170,
    bottom: 10,
    right: 10
  },
  notaNumber:{
    background: "#b5b5b5",
    fontSize: "10px !important",
    width: 18,
    height: 18,
    borderRadius: 9,
    color: "white"
  },
  drawer:{
    "& .MuiDrawer-paper":{
      [theme.breakpoints.up('md')]: {
        maxWidth: "50%",
      },
      padding: "0 16px",
    }

  }
}));


export default function DetallesUsuario() {

  let dispatch = useAppDispatch();
  let {byId:appUser = ({} as IAppUser), status} = useAppSelector(state => state.appUsers);

  let { usuId } = useParams();

  const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
  const classes = useStyles();
  const [showAllInfo, setShowAllInfo] = useState(true);

  const [tableTab, setTableTab] = useState(1);
  const [openMenu, setOpenMenu] = useState<null | HTMLElement>(null);
  const [addPagoModal, setAddPagoModal] = useState(false);
  const [editarForm, setEditarForm] = useState<boolean>(false);
  const [sendNoti, setSendNoti] = useState<boolean>(false);

  useEffect(() => {
    if (usuId)
      dispatch(mostrarAppUserById(+usuId));
  }, [dispatch, usuId]);



  const [printMenu, setPrintMenu] = React.useState<null | HTMLElement>(null);

  const anchorRef = React.useRef<HTMLDivElement>(null);

  return (
      <>
        <AppBar title={Strings.detalles}/>
        <div className={"contentInner "+classes.contentInner}>
          {status === "loading" && !editarForm && <LoadingProgress vh/>}
            <Grid container spacing={smVewport?0:2}>
              <Grid item xs={12} md={3}>
                <div className={classes.clientAvatar+"  estado"+appUser.estado}>
                  <div className={classes.imgCont}>
                    <img height="100" width="100" alt="Avatar" src={appUser.logo? appUser.logo : NoImg} className={classes.imgCircle} />
                  </div>
                  <div>
                    <Typography  noWrap={true} color="inherit" fontWeight={500}>{appUser.nombre}</Typography>
                    <Typography  noWrap={true} color="inherit">{appUser.telefono} {appUser.email ? " / "+appUser.email: ""} </Typography>

                  </div>
                </div>
                <div className={classes.estado + (appUser.inactivo ? " cancelado":(appUser.tipoAviso ? " aviso":"")) + ((appUser?.cuotasAtrasadas??0) > 0 ? " cuotasAtrasadas":"")}>
                  {appUser.inactivo ? (
                      "Inactivo"
                  ):(
                      <>
                        {(appUser.tipoAviso ? "Aviso": "Activo")}

                        {(appUser?.cuotasAtrasadas??0) > 0  ? <> / {appUser?.cuotasAtrasadas} Cuotas Atrasadas</>:"" }
                      </>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} md={9}>
                <div className={(showAllInfo?"all":"")+" "+classes.info} onClick={()=>{if(!(window as any).getSelection().toString()) setShowAllInfo(!showAllInfo);}}>
                  <Grid container >
                    {!showAllInfo && <MoreHoriz className={classes.btnMoreInfo}/>}
                    {showAllInfo &&
                        <Grid item xs={12} className={classes.moreInfo}>
                          <Grid container>
                            {!!appUser.appName &&
                                <Grid item xs={4}  className={classes.itemInfo}>
                                  <span>AppName: </span><span>{appUser.appName}</span>
                                </Grid>
                            }
                            <Grid item xs={4}  className={classes.itemInfo}>
                              <span>Fecha Registro: </span>
                              <span>{formatDate(appUser.fechaCreacion,"DD MMM YYYY h:mm a")}</span>
                            </Grid>
                            {/*<Grid item xs={4}  className={classes.itemInfo}>*/}
                            {/*    <span>Tipo: </span>*/}
                            {/*    <span>{usuTipo?.value}</span>*/}
                            {/*</Grid>*/}

                            <Grid item xs={4}  className={classes.itemInfo}>
                              <span>{Strings.clientes}: </span>
                              <span>{appUser.clientesActivos}</span>
                            </Grid>

                            <Grid item xs={4}  className={classes.itemInfo}>
                              <span>Pagos Realizados: </span>
                              <span>{appUser.pagosRealizados}</span>
                            </Grid>
                            {!!appUser.fechaUltimoPago &&
                                <Grid item xs={4}  className={classes.itemInfo}>
                                  <span>Ultimo pago: </span><span>{formatDate(appUser.fechaUltimoPago,"DD MMM YYYY h:mm a")}</span>
                                </Grid>
                            }


                            {/*{!!appUser.usuOrderId &&*/}
                            {/*<Grid item xs={4}  className={classes.itemInfo}>*/}
                            {/*    <span>paypal OrderId: </span>*/}
                            {/*    <span>{appUser.usuOrderId}</span></Grid>*/}
                            {/*}*/}

                            <Grid item xs={4}  className={classes.itemInfo}>
                              <span>ID:</span>
                              <span>{appUser.id}</span>
                            </Grid>
                            <Grid item xs={4}  className={classes.itemInfo}>
                              <span>País:</span>
                              <span>{appUser.pais}</span>
                            </Grid>
                            <Grid item xs={4}  className={classes.itemInfo}>
                              <span>Contratos:</span>
                              <span>{appUser.contratos} de   {appUser.maxContratos}</span>
                            </Grid>
                          </Grid>
                        </Grid>
                    }


                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>Titular Usuario: </span>
                      <span><b>{appUser.titularInicioSesion}</b></span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>Titular Nombre: </span>
                      <span><b>{appUser.titularNombre}</b></span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>Titular Teléfono: </span>
                      <span onClick={(e)=> {
                        e.stopPropagation();
                        window.open(`https://wa.me/${appUser.titularTelefono}?text=${Strings.hola}, ${appUser.titularNombre}. `)
                      }}><b>{appUser.titularTelefono}</b></span>
                    </Grid>


                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>{Strings.monto} {Strings.cuotas}:</span>
                      <span>{formatPeso(appUser.montoCuota)}</span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>{Strings.proximo + " " + Strings.pago}:</span>
                      <span>{formatDate(appUser.proximoPago)}</span>
                    </Grid>

                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>Plan:</span>
                      <span>{appUser.tipoPlanString}</span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>Préstamos:</span>
                      <span>{appUser.prestamosActivos} de {appUser.maxPrestamos}</span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>Agentes:</span>
                      <span>{appUser.agentes} de  {appUser.maxAgentes}</span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>Cajas:</span>
                      <span>{appUser.cajas} de {appUser.maxCajas}</span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>Max Rutas:</span>
                      <span>{appUser.maxRutas}</span>
                    </Grid>


                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>Cuenta destino:</span>
                      <span>{appUser.cuentaDestino || "-"}</span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>Paypal:</span>
                      {!!appUser.suscriptionId ?(
                          <span onClick={(e)=>{
                            e.stopPropagation()
                            window.open("https://www.paypal.com/billing/subscriptions/"+appUser.suscriptionId)
                          }}>{appUser.suscriptionId}</span>
                      ):(
                          <span>-</span>
                      )}
                    </Grid>


                  </Grid>
                </div>
                <Hidden only={"xs"}>
                  <Paper className={"d-print-none " +classes.controls}>
                    <div style={{minWidth: 867, paddingBottom: 3}}>
                          <Button disableElevation disabled={appUser.inactivo} size={"small"} onClick={()=> setAddPagoModal(true)}
                                  color={"primary"} variant={"contained"}>{Strings.agregar} {Strings.pago}</Button>

                            <Button size="small" className={classes.button} onClick={()=>setEditarForm(true)}> {Strings.editar}</Button>

                      <Button size="small" className={classes.button} onClick={()=>setSendNoti(true)}> {Strings.notificacion}</Button>


                      {/*<Button size="small" color="secondary" className={"text-red "+classes.button}*/}
                            {/*        onClick={()=> pushUrl({modalCancel:appUser.id})}>{Strings.anular}</Button>*/}



                      <Button size="small" className={classes.button}
                              onClick={(e)=>setPrintMenu(e.currentTarget)}
                              endIcon={<KeyboardArrowDown />}
                      >{Strings.imprimir}</Button>

                    </div>
                  </Paper>

                  <Menu
                      anchorEl={printMenu}
                      open={Boolean(printMenu)}
                      onClose={()=>setPrintMenu(null)}
                  >
                    <MenuItem onClick={()=> {
                      setPrintMenu(null)
                    } }>{Strings.imprimir} {Strings.contrato}</MenuItem>
                    <MenuItem onClick={()=> {
                      setPrintMenu(null)
                    } }>{Strings.imprimir} {Strings.estado}</MenuItem>
                  </Menu>
                </Hidden>
              </Grid>
              <Hidden smUp>

                <ButtonGroup variant="contained" ref={anchorRef} fullWidth aria-label="split button" sx={{m:1,mb:0}}>
                  <Button onClick={()=> setAddPagoModal(true)} disabled={appUser.inactivo}
                          >{Strings.agregar} {Strings.pago}</Button>
                  <Button
                      size="small"
                      aria-haspopup="menu"
                      onClick={(e)=>setOpenMenu(e.currentTarget)}
                      sx={{width: "54px"}}
                  >
                    <ArrowDropDown />
                  </Button>
                </ButtonGroup>
                <Menu id="long-menu" anchorEl={openMenu} keepMounted open={Boolean(openMenu)} onClose={()=>setOpenMenu(null)}>
                      <MenuItem onClick={()=>{
                        setOpenMenu(null)
                        setEditarForm(true)
                      }}>{Strings.editar}</MenuItem>

                  <MenuItem className={"text-red"} onClick={()=>setSendNoti(true)}> {Strings.notificacion}</MenuItem>

                      {/*<MenuItem className={"text-red"} onClick={()=> pushUrl({modalCancel:appUser.id})}>{Strings.anular} {Strings.prestamo}</MenuItem>*/}

                  {/*<MenuItem onClick={()=>navigate(pathname, {state: {...hState, contactar:{*/}
                  {/*              prestamoId: appUser.id,*/}
                  {/*            }}})}*/}
                  {/*>{Strings.contactar}</MenuItem>*/}

                </Menu>
              </Hidden>
            </Grid>
          {!!appUser.comentario?.length &&
            <Typography bgcolor={"#fbf3dd"} p={1} fontSize={14} mt={1} mb={-1}>
              <b>Comentario: </b>
              {appUser.comentario}
            </Typography>
          }
          <div className={classes.table}>
              {/*{tableTab === 1 && <ListPagos notasCount={appUser?.notas?.length} onTabClick={setTableTab} onClickPendiente={onClickPendiente} showSeguro={!!appUser.montoSeguro} pagos={appUser.pagos?appUser.pagos:[]} />}*/}
              {/*{tableTab === 3 && <ListNotasUser notasCount={appUser?.notas?.length} onTabClick={setTableTab} data={appUser.notas??[]}/>}*/}

              {tableTab === 1 &&
                <ListPagosUser
                    notasCount={appUser?.notas?.length}
                    onTabClick={setTableTab}
                    data={appUser.pagos??[]}
                />
              }
              {tableTab === 2 &&
                  <ListModulosUser
                      notasCount={appUser?.notas?.length}
                      onTabClick={setTableTab}
                      data={appUser.modulos??[]}
                  />
              }

              {tableTab === 3 &&
                <ListNotasUser
                    notasCount={appUser?.notas?.length}
                    onTabClick={setTableTab}
                    data={appUser.notas??[]}
                />
              }
            </div>


        </div>

        {!appUser.inactivo &&
          <AgregarPagoUser open={addPagoModal} onClose={()=>setAddPagoModal(false)}/>
        }
        <Drawer className={classes.drawer} anchor={"right"} open={editarForm} onClose={()=>setEditarForm(false)}>
          <EditarDrawer onClose={()=>setEditarForm(false)}/>
        </Drawer>

        <EnviarNotificacion companiaId={sendNoti?appUser.id: undefined} onClose={()=>setSendNoti(false)}/>





      </>
  );


}
